import React, { useState, useEffect } from 'react'
import MobileYourQuoteHeader from './MobileYourQuoteHeader'
import "./OperationStepsMobile.scss"
import VinPopIn from '../VinPopIn'
import ForfaitList from '../ForfaitList'
import fetchApiData from '../../../apiHandlers/fetchApiData'
import { useSelector, useDispatch } from 'react-redux'
import ComplementaryOperations from '../ComplementaryOperations'
import CONSTANTS from '../../../Constants'
import warningImg from '../../../images/AP/ap-Alert-Outline.svg'
import PopIn from '../../PopIn/PopIn'
import { setSelectedMandatoryAdditionalForfaitsToStore } from '../../../redux-files/actions/action';
import { pushEventToGTM } from '../../../helpers/trackerManager'
import { priceFormat, isMobile } from '../../../helpers/helpers'
// import useScrollTop from '../../../custom-Hooks/useScrollTop'

// this componenet work only in Mobile 
const OperationStepsMobile = (props) => {
    const dealer = useSelector(state => state.ndel_store.dealer)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const selectedMandatoryForfaitsFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedPasKilometriqueFromStore = useSelector(state => state.ndel_store.selectedMileageSteps)

    const [isPasKiloDisabled, setIsPasKiloDisabled] = useState(true)
    const [pasKilometriqueList, setPasKilometriqueList] = useState([])
    const [selectedPasKilometrique, setSelectedPasKilometrique] = useState(selectedPasKilometriqueFromStore)
    const [revisionConstructorForfait, setRevisionConstructorForfait] = useState([])
    const [selectedForfaits, setSelectedForfaits] = useState(selectedForfaitFromStore)
    const [showVinPopin, setShowVinPopIn] = useState(true)
    const [showComplementaryOperations, setShowComplementaryOperations] = useState(false)
    const [selectedMandatoryForfait, setSelectedMandatoryForfait] = useState(selectedMandatoryForfaitsFromStore)
    const [selectedRevisionForfait, setSelectedRevisionForfait] = useState({})
    const [showMandatoryOperationsPopIn, setShowMandatoryOperationsPopIn] = useState(false)
    const [totalPrice, setTotalPrice] = useState(0)
    const dispatch = useDispatch()
    useEffect(() => {
        if (props.selectedOperation.codeFamilyForfait !== 'FCT0002') {
            setShowVinPopIn(false)
        }
    }, [])
    const loadPas = (vin = vehicleInfo.SerialNumber) => { // function to call the API getPas Kilometrique 
        console.log('loadPAs')
        const pasKilometriqueAPI = new fetchApiData()
        pasKilometriqueAPI.getPas({
            "geoID": dealer.geoID,
            "mileage": vehicleInfo.Mileage,
            "vin": vin
        }).then(
            data => {
                let pasKilometriqueList = []
                pasKilometriqueList[""] = CONSTANTS.LABELS.needs_basket_maintenance_label5;
                data.d.map(res => {
                    pasKilometriqueList[res.Value] = res.Text;
                });
                setPasKilometriqueList(pasKilometriqueList)
                setIsPasKiloDisabled(false)
            })
            .catch(error => {
                console.error('error getPas : ', error)

            });
    }
    const handleSave = (selectedPasKilometrique) => { // to save the selected kilometrique step, hide the vin popup and show the mileage select
        // setPasKilometriqueList(pasKilometriqueList)
        console.log(selectedPasKilometrique)
        setSelectedPasKilometrique(selectedPasKilometrique)
        setShowVinPopIn(false)
        loadForfaitEntretien(selectedPasKilometrique.key)
    }

    const loadForfaitEntretien = (selectedPasKilometrique) => { // function to load the Annual service Forfaite 
        const ForfaitEntretienApi = new fetchApiData()
        ForfaitEntretienApi.getForfaitEntretien(selectedPasKilometrique).then(

            res => {
                let forfaitList = res.d.FunctionData.SubFunctionList[0].ForfaitList
                forfaitList.forEach(element => {
                    element.forfaitFamilyCode = res.d.FunctionData.SubFunctionList[0].Code
                });
                setRevisionConstructorForfait(forfaitList)
            }
        )

    }

    const handleOnAddForfait = (selectedForfaits) => {
        let finalPrice = calculateTotalPrice(selectedForfaits, selectedMandatoryForfait)
        setSelectedForfaits(selectedForfaits)
        setTotalPrice(finalPrice)
        if (props.selectedOperation.codeFamilyForfait === 'FCT0002') {
            setSelectedRevisionForfait(revisionConstructorForfait.filter(forf => forf.isChecked))
            setShowComplementaryOperations(true)
        }
        else {
            props.handleClick(finalPrice); // to go back to the operations list
        }
        setShowVinPopIn(false)
    }

    //when the button continue is clicked on Mobile 
    const handleComplementaryOperationButtonClicked = (selectedMandatoryOperations) => {
        if (selectedMandatoryOperations.length > 0) {
            setShowComplementaryOperations(false);
            setShowVinPopIn(false);
            props.handleClick(calculateTotalPrice(selectedForfaits, selectedMandatoryOperations)); // to go back to the operations list
            dispatch(setSelectedMandatoryAdditionalForfaitsToStore(selectedMandatoryOperations))
        } else {
            setShowMandatoryOperationsPopIn(true)
        }

    }

    const calculateTotalPrice = (selectedForfaits, selectedMandatoryOperations = []) => {
        if (selectedMandatoryOperations.length < 1) {
            let totalPrice = selectedForfaits.reduce((prevValue, currentValue) =>
                prevValue + currentValue.Items[0].Prix, 0)

            return totalPrice
        }
        let addMandatoryOperationsToForfaits = selectedForfaits.concat(selectedMandatoryOperations)
        let totalPrice = addMandatoryOperationsToForfaits.reduce((prevValue, currentValue) =>
            prevValue + currentValue.Items[0].Prix, 0)

        return totalPrice
    }

    const handleDeleteOperation = () => {
        props.onDeleteOperation(props.selectedOperation);
    }
    const handleEditForfaitForRevisionConst = () => {
        setShowComplementaryOperations(false)
    }
    const handleEditMilesYears = () => {
        setShowVinPopIn(true)
    }

    // the content of the mandatory operation  popin shown when clicked on Continue without selecting a complementary forfait (only in annual service'Revision constructeur')
    const popInVehicleContent = <div className='popin-mandatory-operations'>
        <p className='label1'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label1}</p>

        <p className='label2'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label2}</p>
        <p className='label3'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label3}</p>

    </div>

    return (

        <>
            <div className='Op-steps-Popin' >
                <MobileYourQuoteHeader handleClick={props.handleGoBack} />
                <div className='headline'>{CONSTANTS.LABELS.header_quote_ariane2}</div>
                <div className='op-block'>
                    <i className='op-icon' style={{ backgroundImage: `url(${props.selectedOperation.Image})` }} ></i>
                    <div className="op-title">
                        {props.selectedOperation.interventionLabel}
                    </div>
                    <i className={`trash-icon`} onClick={handleDeleteOperation} />
                </div>
                {props.selectedOperation.codeFamilyForfait === 'FCT0002' && showVinPopin && <VinPopIn
                    onSave={handleSave}
                    onLoadPas={loadPas}
                    options={pasKilometriqueList}
                    isSecondeStapeDisabled={isPasKiloDisabled}
                />}
                {!showVinPopin && !showComplementaryOperations &&
                    <>
                        <div className='pacakge-choice'>{CONSTANTS.LABELS.needs_quote_package}</div>
                        {props.selectedOperation.interventionForfaits[0].isConstructeur &&
                            <div className='row-block'>
                                <div className='km-pair' dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.needs_quote_miles !== undefined && CONSTANTS.LABELS.needs_quote_miles.replace('[km_years]', selectedPasKilometrique.value) }}></div>
                                <div className='edit-link' onClick={handleEditMilesYears}>{CONSTANTS.LABELS.common_v2_modify}</div>
                            </div>}



                        <ForfaitList
                            onSelectedForfait={handleOnAddForfait}
                            operationForfaits={props.selectedOperation.interventionForfaits}
                            pasKilometrique={selectedPasKilometrique}
                            revisionConstructorForfait={revisionConstructorForfait} />
                    </>
                }

                { /*complementary addition Operations Block Only for annual Services*/}
                {showComplementaryOperations &&
                    <div className='mandatory-operation-block'>
                        <div className='mandatory-operations-headline'>{CONSTANTS.LABELS.needs_basket_maintenance_label7}</div>
                        <div className='forfait-info-block'>
                            <div className='forfait-info'
                                dangerouslySetInnerHTML={{ __html: `${CONSTANTS.LABELS.needs_quote_package1.replace('[package_name]', selectedRevisionForfait[0].Libelle)} <strong>${priceFormat(selectedRevisionForfait[0].Items[0].Prix)} ${CONSTANTS.LABELS.needs_basket_label2}</strong>` }}
                            >
                            </div>
                            <div className='edit-link' onClick={handleEditForfaitForRevisionConst}>{CONSTANTS.LABELS.common_v2_modify}</div>
                        </div>
                        <ComplementaryOperations
                            complementaryOperations={selectedRevisionForfait[0].Operations}
                            forfaitPrice={selectedRevisionForfait[0].Items[0].Prix}
                            onComplementaryOperationsButtonClicked={handleComplementaryOperationButtonClicked}
                        />
                    </div>
                }
                {/* end of ComplementaryAddition services Block */}

            </div>

            { //popin s'affiche quand les operations complementaire ne sont pas selectionnées 
                showMandatoryOperationsPopIn && <PopIn
                    title={CONSTANTS.LABELS.needs_basket_maintenance_alert_title}
                    content={popInVehicleContent}
                    titlePicto={
                        {
                            showTitlePicto: true,
                            src: warningImg,
                            alt: 'warning'
                        }
                    }
                    primaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_choose}
                    secondaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore}
                    handlePrimaryButton={() => { //asking user to choose a mandatory operation
                        setShowMandatoryOperationsPopIn(false);
                        pushEventToGTM({
                            pageName: 'services - révision - popin additional Operation',
                            eventAction: 'Select::Popin::AdditionalOperation',
                            eventLabel: CONSTANTS.LABELS.needs_basket_maintenance_alert_choose,
                            eventCategory: 'Content'
                        })
                    }
                    }
                    handleSecondaryButton={() => { // user ignore Mandatory Operations
                        setShowMandatoryOperationsPopIn(false);
                        props.handleClick(totalPrice);
                        pushEventToGTM({
                            pageName: 'services - révision - popin additional Operation',
                            eventAction: 'Select::Popin::AdditionalOperation',
                            eventLabel: CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore,
                            eventCategory: 'Content'
                        })
                    }
                    }
                />}

        </>
    )
}
export default OperationStepsMobile;